import React from "react";
import styled from "styled-components";

export const IconBackground = styled.div`
  background-color: ${p => p.color};
  width: ${p => p.width}px;
  height: ${p => p.height}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = (svg, alt) => {
  // callers can pass *any* attributes native to the <img>
  // tag (i.e. width, height, etc)
  const SvgIcon = props => {
    return <img src={svg} alt={alt} {...props} />;
  };

  return SvgIcon;
};

export default Icon;
